/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowTriviaGameTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowTriviaGame,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Test Our Knowledge!",
    "Trivia Night Challenge!",
    "Who Knows Best?",
  ],
  title: "Trivia Game Night",
  description: "Organize a fun trivia game night.",
  longDescription:
    "Gather your friends for an entertaining trivia game night! Choose a date, decide on the trivia categories, and plan snacks for the evening!",
  emoji: "❓",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Trivia Game Night",
          emoji: "❓",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the trivia game night?",
          emoji: "📅",
          completeAction: {
            question: "Decide on trivia categories?",
            description:
              "What categories should we include in the trivia game?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What trivia categories should we choose?",
                emoji: "📚",
                completeAction: {
                  question: "Decide on snacks?",
                  description:
                    "What snacks should we have during trivia night?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What snacks should we bring?",
                      emoji: "🍿",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let the Games Begin!",
    outroDescription: "Your trivia game night plans are set! Enjoy the fun!",
  },
};
